export default {
    computed: {
        getExceptionStatus () {
            return [
                {
                    value: 0,
                    label: "推送异常"
                },
                {
                    value: 1,
                    label: "回传异常"
                },
                {
                    value: 2,
                    label: "取消异常"
                },
                {
                    value: 6,
                    label: "完成异常"
                },
                {
                    value: 7,
                    label: "发运异常"
                },
                {
                    value: 11,
                    label: "附件推送异常"
                }
            ]
        },
        getStatus() {
            return [
                {
                    value: 0,
                    label: '草稿',
                    color: "color-confirm"
                },
                {
                    value: 5,
                    label: '待审核',
                    color: "color-warning"
                },
                {
                    value: 6,
                    label: '审核拒回',
                    color: "color-error"
                },
                {
                    value: 10,
                    label: '待发货',
                    color: "color-confirm"
                },
                {
                    value: 15,
                    label: '待入库',
                    color: "color-primary"
                },
                {
                    value: 20,
                    label: '入库中',
                    color: "color-warning"
                },
                {
                    value: 25,
                    label: '待出库',
                    color: "color-primary"
                },
                {
                    value: 30,
                    label: "出库中",
                    color: "color-warning"
                },
                {
                    value: 70,
                    label: '已完成',
                    color: "color-success"
                },
                {
                    value: 100,
                    label: '已取消',
                    color: "color-error"
                }
            ]
        },
        getShipType () {
            return [
                {
                    value: 1,
                    label: "仓库安排"
                },
                {
                    value: 2,
                    label: "亚马逊自提"
                }
            ]
        },
        getOperateType () {
            return [
                {
                    value: 100,
                    label: "保存"
                },
                {
                    value: 200,
                    label: "更新"
                },
                {
                    value: 210,
                    label: "提交"
                },
                {
                    value: 215,
                    label: "撤销审核"
                },
                {
                    value: 220,
                    label: "发运"
                },
                {
                    value: 400,
                    label: "取消"
                },
                {
                    value: 500,
                    label: "审核通过"
                },
                {
                    value: 600,
                    label: "审核拒回"
                },
                {
                    value: 720,
                    label: "确认"
                },
                {
                    value: 800,
                    label: "完成"
                },
                {
                    value: 810,
                    label: "入库完成"
                },
                {
                    value: 820,
                    label: "出库完成"
                },
                {
                    value: 10,
                    label: "推送附件"
                },
                {
                    value: 930,
                    label: "推送仓库"
                },
                {
                    value: 1046,
                    label: "到仓确认"
                },
                {
                    value: 1073,
                    label: "仓库回写"
                }
            ]
        },
        /**
         * 货物形态
         */
        getGoodsType() {
            //             CONTAINER_CARTON(2,"集装箱+纸箱"),
            // CARTON(4,"卡车+纸箱"),
            // CARTON_OTHER(5,"卡车+散货"),
            // OTHER(6,"集装箱+散货");

            //1:集装箱+纸箱 2:卡车+纸箱 3:集装箱+托盘 4:卡车+托盘 5:散货
            return [
                { value: 2, label: this.$t('fbb.inbound.container', { defaultValue: '集装箱' }) },
                { value: 4, label: this.$t('fbb.inbound.truck', { defaultValue: '卡车' }) },
                // { value: 3, label: '集装箱+托盘' },
                // { value: 4, label: '卡车+托盘' },
                // { value: 5, label: '卡车+散货' },
                // { value: 6, label: '集装箱+散货' },
            ]
        },
        getBoundStatus() {
            return [
                {
                    value: 0,
                    label: "草稿"
                },
                {
                    value: 5,
                    label: "已确认"
                },
                {
                    value: 10,
                    label: "已取消"
                }
            ]
        }
    },
    methods: {
        handleParams (params) {
            let data = {
                ...params
            };
            if (data.search && data.search.CN_CartonNo) {
                data.cartonNo = data.search.CN_CartonNo;
                delete data.search.CN_CartonNo;
            }
            else {
                delete data.cartonNo;
            }
            return data;
        },
    }
}